export default __webpack_public_path__ + "static/media/illus08.2195eb88.png";